// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"b06e4bfe","513":"6da96b08","703":"36b72a45","787":"33f32a45"}[chunkId] + ".chunk.js";
};